import { Dialog, DialogActions, DialogContent, Grid } from '@material-ui/core';
import React, { useState } from 'react'
import AppBarModal from '../../general/AppBarModal';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { BtnForm } from '../../general/BotonesAccion';
import DateFnsUtils from '@date-io/date-fns';
import TareasTerminadas from '../../general/TareasTerminadas';
import { consulta } from '../../../global/js/funciones';
import moment from 'moment';

const ModalEditarFechaExamen = ({ modalEditarFechaExamen, mostrarModalEditarFechaExamen, estado, actualizarMensaje, obtenerEstadosValidaciones }) => {
    const [fechaExamen, setFechaExamen] = useState(estado.fecha_examen);
    const [cargando, setCargando] = useState(false);
    let validacion_id = estado.validacion;

    const handleGuardar = () => {
        setCargando(true);
        consulta(`api/v1.0/validaciones/actualizar_fecha_examen/${validacion_id}`, { fecha_examen: moment(fechaExamen).format('YYYY-MM-DD') }, 'PUT', (error, estado, resp) => {
            if (estado === 200) {
                obtenerEstadosValidaciones(validacion_id);
                actualizarMensaje({ titulo: 'Fecha de examen actualizada', tipo: 'success', mostrar: true, tiempo: 6000 });
                mostrarModalEditarFechaExamen(false);
            } else if (estado === 302) actualizarMensaje({ titulo: resp.titulo, tipo: 'warning', mostrar: true, tiempo: 6000 });
            else actualizarMensaje({ titulo: 'Error al actualizar la fecha de examen', tipo: 'error', mostrar: true, tiempo: 6000 });
        });
        setCargando(false);
    };

    return (
        <>
            <Dialog open={modalEditarFechaExamen} maxWidth="xs" fullWidth={true} onClose={() => mostrarModalEditarFechaExamen(false)}>
                <AppBarModal titulo='¡ Editar Fecha Examen !' mostrarModal={mostrarModalEditarFechaExamen} titulo_accion='' />
                <DialogContent style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }} className='scroll' >
                    {
                        cargando ?
                            <TareasTerminadas mensaje='Cargando...' marginTop='5%' />
                            :
                            <Grid >
                                <MuiPickersUtilsProvider utils={DateFnsUtils} >
                                    <KeyboardDatePicker
                                        required={true}
                                        style={{ marginTop: 3, width: '100%' }}
                                        minDate={Date("YYYY-MM-dd")}
                                        margin="normal"
                                        label="Fecha del examen"
                                        format="yyyy-MM-dd"
                                        value={fechaExamen}
                                        onChange={(fechaExamen) => setFechaExamen(fechaExamen)}
                                        KeyboardButtonProps={{
                                            'aria-label': 'change date',
                                        }}
                                        minDateMessage={`La fecha debe ser mayor que la fecha actual.`}
                                        invalidDateMessage='Formato Invalido'
                                    />
                                </MuiPickersUtilsProvider>
                            </Grid>
                    }
                </DialogContent>
                <DialogActions>
                    <BtnForm texto="Guardar" callback={() => handleGuardar()} />
                    <BtnForm texto="Cerrar" callback={() => mostrarModalEditarFechaExamen(false)} />
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModalEditarFechaExamen